/**
 * Represents Error Codes from [{@link Player}]
 */
const PLAYER_ERROR_BASE = 0x0200;
export const PlayerErrorCodes = Object.freeze({
  /**
   * Indicates that an Error has occurred while Loading the MediaSource
   * __Possible Reasons:__
   * - Manifest Failure
   * - Chunk Failure
   */
  MEDIA_SOURCE_FAILURE: PLAYER_ERROR_BASE + 0x01,

  /**
   * Indicates that Fetching of the Media Source from Network Timed-Out
   * __Possible Reasons :__
   * - Manifest Fetch Timeout
   * - Chunk Fetch Timeout
   */
  MEDIA_SOURCE_TIMEOUT: PLAYER_ERROR_BASE + 0x02,

  /**
   * Indicates that an Error has occurred while Provisioning Model Certificates on
   * the specific Device
   */
  DRM_PROVISIONING_FAILURE: PLAYER_ERROR_BASE + 0x03,

  /**
   * Indicates that Fetching of DRM Provisioning Data from Network Timed-Out
   */
  DRM_PROVISIONING_TIMEOUT: PLAYER_ERROR_BASE + 0x04,

  /**
   * Indicates that an Error has occurred while Loading DRM Keys for a particular
   * Content either from Network (or) from Persistent Storage
   */
  DRM_LICENSE_FAILURE: PLAYER_ERROR_BASE + 0x05,

  /**
   * Indicates that Fetching of DRM Keys from Network Timed-Out
   */
  DRM_LICENSE_TIMEOUT: PLAYER_ERROR_BASE + 0x06,

  /**
   * Indicates that Loaded DRM Keys are Expired
   */
  DRM_LICENSE_EXPIRED: PLAYER_ERROR_BASE + 0x07,

  /**
   * Indicates that Playback of Media Failed
   * __Possible Reasons :__
   * - Decoder Init Failure
   * - Decoder Support Unavailable for the specified Format
   * - Media Buffer Enqueue Failed because of Crypto Exception etc.,
   */
  MEDIA_PLAYBACK_FAILURE: PLAYER_ERROR_BASE + 0x08,

  /**
   * Player failed as it was inactive for a longer duration and the underlying resources
   * have been collected by the Operating System
   */
  MEDIA_PLAYBACK_STALE: PLAYER_ERROR_BASE + 0x09,

  /**
   * Player is Out Of Memory and is unable to allocate Resources.
   * The primary reason for this error is not releasing Player resources Properly.
   * It's also possible that too-many instances of Player has been created Simultaneously.
   * [{@link Player.stop}]
   */
  OUT_OF_MEMORY_ERROR: PLAYER_ERROR_BASE + 0x0a,

  /**
   * Device failed to handle the Media Content.
   * __Possible Reasons:__
   * - Device/Browser Doesn't have the necessary Hardware to Handle the Media Content
   * - Device Media / DRM Stack is in a Stale State and Device needs a Restart.
   * - Device/Browser's output device is not compatible for the playback.
   * - Output device source is switched to another input device source.
   */
  SYSTEM_FAILURE: PLAYER_ERROR_BASE + 0x0b,

  /**
   * Browser has failed to handle the Unsupported Media Content.
   * __Possible Reasons:__
   * - Player support AES-128 encryption with HLS yet.
   * - The HLS parser has encountered encrypted content with unsupported KEYFORMAT attributes.
   * - The key system is not supported.
   * - The content container or codecs are not supported by this browser.
   * For example, this could happen if the content is WebM,
   * but your browser does not support the WebM container,
   * or if the content uses HEVC, but your browser does not support the HEVC codec.
   * This can also occur for multicodec or multicontainer manifests if none of the codecs or
   * containers are supported by the browser.
   * To see what your browser supports, you can check the JSON data dumped by http://support.shaka-player-demo.appspot.com/
   */
  CONTENT_UNSUPPORTED_BY_BROWSER: PLAYER_ERROR_BASE + 0x10,

  /**
   * Indicates that player buffer timeout
   * ____Possible Reasons:__
   * Player has more resilient over http error codes,
   * It could leads the player indefinite buffering
   * to treat this as a error we exposed the configuration in
   * `playbackOptions` as `bufferTimeoutMs`
   * If the player buffering does not end with in given timeout, the below error happen.
   */
  BUFFER_TIMEOUT: PLAYER_ERROR_BASE + 0x15,

  /**
   * Indicates that Playback has failed because the output device/connection does not
   * meet the HDCP compliance level required by the DRM license.
   * __Possible Reasons:__
   * - The DRM license/key requires an HDCP version that the connected display/output
   *   does not support.
   * - The output is restricted (e.g., non-HDCP compliant HDMI/display, screen mirroring,
   *   or capture device connected).
   */
  HDCP_COMPLIANCE_FAILURE: PLAYER_ERROR_BASE + 0x1d,
});
